import { createLocalVue, shallowMount } from "@vue/test-utils";
import Mensaje from "@/views/Mensaje";
import Vuex from "vuex";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("Mensaje component", () => {
  let wrapper;
  let store;

  beforeEach(() => {
    store = new Vuex.Store({
      state: {
        paso1: {
          nombre: "Lara",
          apellido: "Croft",
          email: "lara@gmail.com",
          celular: {
            area: "011",
            numero: "12313212"
          },
          documento: {
            tipo: "DNI",
            numero: "35999888"
          }
        }
      },
      getters: {
        getPaso1: function (state) {
          return function () {
            return state.paso1;
          };
        }
      }
    });

    wrapper = shallowMount(Mensaje, {
      store,
      localVue,
      mocks: {
        gtmOnSystemError: () => "",
        $route: {
          params: {
            mje: 1
          }
        }
      }
    });
  });

  it("Renders del component Mensaje", () => {
    expect(wrapper).toBeDefined();
  });
});
